import { SchemaNode } from './schema-node';

const PATH_DELIMITER = ':';

export type SchemaToModelMapping = Record<string, string>;
export type ModelGetter<TModelSchema> = (_modelName: string) => TModelSchema;

export class Schema<TModelSchema = unknown> {
  modelGetter: ModelGetter<TModelSchema>;

  modelToSchemaMapping: Record<string, string[]>;

  root: SchemaNode<TModelSchema>;

  schemaToModelMapping: SchemaToModelMapping;

  constructor(schemaToModelMapping: SchemaToModelMapping, modelGetter: ModelGetter<TModelSchema>) {
    this.root = new SchemaNode<TModelSchema>('$ROOT', null, null);
    this.schemaToModelMapping = schemaToModelMapping;
    this.modelGetter = modelGetter;
    this.modelToSchemaMapping = {};
    this.buildModelToSchemaMap();

    this.insert = this.insert.bind(this);
    this.getSchemaNames = this.getSchemaNames.bind(this);
  }

  buildModelToSchemaMap() {
    Object.keys(this.schemaToModelMapping).forEach(schemaName => {
      const modelName = this.schemaToModelMapping[schemaName];
      if (!this.modelToSchemaMapping[modelName]) {
        this.modelToSchemaMapping[modelName] = [];
      }
      this.modelToSchemaMapping[modelName].push(schemaName);
    });
  }

  getSchemaNames(modelName: string) {
    return this.modelToSchemaMapping[modelName];
  }

  insert(path: string) {
    const parts = path.split(PATH_DELIMITER);
    let currentNode = this.root;

    for (let i = 0; i < parts.length; i += 1) {
      const partName = parts[i];
      const existingNode = currentNode.childNodes.find(node => node.name === partName);
      if (existingNode) {
        currentNode = existingNode;
      } else {
        const modelName = this.schemaToModelMapping[partName];
        if (!modelName) {
          throw new Error(`Model name not found for schema name(data path) ${partName}`);
        }
        const newNode = new SchemaNode(partName, modelName, currentNode, this.modelGetter(modelName));
        currentNode.childNodes.push(newNode);
        currentNode = newNode;
      }
    }

    if (window.__OVERREACT_DEVTOOLS__) {
      window.__OVERREACT_DEVTOOLS__.getSchema(this.root.toJson());
    }
    return currentNode;
  }
}

export { SchemaNode } from './schema-node';
export type {
  SchemaNodeExtension, SchemaNodeJson, SchemaNodeLike, SchemaNodeParent,
} from './schema-node';
